import { ControlType, v2 } from '@sap/ux-specification-types';
import type { AnalyticalTable } from '../controls/Table';
import { pageLayoutInformation, childId, syncRule } from '../../../common/decoration/decorators';
import { buildControlIdForPage } from '../../../common/decoration';

@pageLayoutInformation({
    id: 'sap.suite.ui.generic.template.AnalyticalListPage.view.AnalyticalListPage',
    pageId: v2.FE_TEMPLATE_V2_ALP
})
export class AnalyticalListPage implements v2.AnalyticalListPageConfigV2 {
    @syncRule({
        flex: {
            controlId: buildControlIdForPage,
            controlType: (): ControlType => ControlType.DynamicPage
        }
    })
    fitContent?: boolean;

    @childId('table')
    table?: AnalyticalTable;

    @childId('template::SmartFilterBar')
    filterBar?: v2.AnalyticalListPageFilterBar;

    @childId('analyticalListPageChart')
    chart?: v2.ChartSettings;

    @childId('analyticalListFooter')
    footer?: v2.GenericFooter;

    keyPerformanceIndicators: {
        [k: string]: v2.KPISettings;
    };
}
